import React, { useState, useEffect } from "react";
import { authenticatedGet } from "../utils/apiUtils";

const QRCodeDisplay = ({ content }) => {
  const [qrCodeData, setQrCodeData] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchQRCode = async () => {
      try {
        setLoading(true);
        setError("");

        // Use the new authenticated fetch utility
        const response = await authenticatedGet(
          `/assets/generate-qrcode?content=${encodeURIComponent(content)}`
        );

        if (!response.ok) {
          throw new Error(`Failed to generate QR code: ${response.status}`);
        }

        const data = await response.json();
        setQrCodeData(data.qrCode); // Base64 data returned by API
      } catch (error) {
        console.error("Error generating QR Code:", error);
        setError("Failed to generate QR code. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchQRCode();
  }, [content]);

  return (
    <div>
      <h2>QR Code</h2>
      {loading ? (
        <p>Loading QR Code...</p>
      ) : error ? (
        <div style={{ color: "red" }}>
          <p>{error}</p>
          <button onClick={() => window.location.reload()}>Retry</button>
        </div>
      ) : qrCodeData ? (
        <img
          src={`${qrCodeData}`}
          alt="Generated QR Code"
          style={{ maxWidth: "300px", maxHeight: "300px" }}
        />
      ) : (
        <p>No QR Code data available.</p>
      )}
    </div>
  );
};

export default QRCodeDisplay;
